import { HttpClient } from "@angular/common/http";
import { DataService } from "./data.service";
import { StateService } from "./state.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Comment } from "../models/comment.model";
import { Result, ResultModel } from "../models/general/result.model";

@Injectable({
    providedIn: 'root',
})
export class CommentService extends DataService {

    constructor(http: HttpClient, stateService: StateService) {
            super(http, stateService);
            this.controllerName = 'comment';
        }

    insertComment(comment: Comment): Observable<Result<Comment>> {
        return this.put('/api/comment/add', comment);
    }

    updateComment(comment: Comment): Observable<Result<Comment>> {
        return this.post('/api/comment/update', comment);
    }

    deleteComment(id: number): Observable<ResultModel> {
        return this.delete(`/api/comment/delete/${id}`);
    }
}